import React, { useState } from "react"
import LogoBar, { Logo } from "./LogoBar"
import "css/nav.scss"
import { useCurrentUser } from "../../../context/user/UserContext"
import NavigationMenu from "./NavigationMenu"
import { colors } from "@carrotfertility/carotene"
import { Box, useMediaQuery, useTheme } from "@carrotfertility/carotene-core"

function MobileNavigation() {
  const [collapsed, setCollapsed] = useState(true)
  const collapseMenu = () => setCollapsed(true)
  const openMenu = () => setCollapsed(false)
  const { isInAppLockdown } = useCurrentUser()
  return (
    <Box bgcolor={colors.base.pampas} minHeight="100%">
      <LogoBar onClick={openMenu} collapsed={collapsed} />
      <NavigationMenu collapsed={collapsed} collapseMenu={collapseMenu} appLockedDown={isInAppLockdown} />
    </Box>
  )
}

function DesktopNavigation() {
  const [collapsed, setCollapsed] = useState(true)
  const collapseMenu = () => setCollapsed(true)
  const { isInAppLockdown } = useCurrentUser()
  return (
    <Box position="fixed" width={{ md: "200px", lg: "256px" }} bgcolor={colors.base.pampas} minHeight="100%">
      <Box
        paddingLeft={(theme) => theme.spacing(theme.tokens.spacing.xl)}
        paddingTop={(theme) => theme.spacing(theme.tokens.spacing.xxl)}
      >
        <Logo />
      </Box>
      <NavigationMenu collapsed={collapsed} collapseMenu={collapseMenu} appLockedDown={isInAppLockdown} />
    </Box>
  )
}

function Navigation(): JSX.Element {
  const theme = useTheme()
  const showDesktop = useMediaQuery(theme.breakpoints.up("md"))
  return showDesktop ? <DesktopNavigation /> : <MobileNavigation />
}

export { Navigation }
